import React from 'react';
import { Helmet } from 'react-helmet-async';
import IntroductionTabs from '../../IntroductionTabs';
import './values.css';

const Values = () => {
  const canonical = 'https://www.xn--o39ap7bo6pk0bo2x.com/intro/values';
  const title = '조직도 - 주식회사 가까운물류';
  const desc = '주식회사 가까운물류의 체계적인 조직 구조를 확인하세요.';

  const organizationData = {
    ceo: 'CEO',
    departments: [
      {
        id: 'Coupang',
        name: '쿠팡사업부',
        tasks: [
          '본사',
          '서울 지사',
          '대구 지사',
          '부산 지사'
        ]
      },
      {
        id: 'transport',
        name: '운송사업부',
        tasks: [
          '본사',
          '대구 지사'
        ]
      },
      {
        id: 'finance',
        name: '총무부',
        tasks: [
        ]
      },
      {
        id: 'shoppingmall',
        name: '쇼핑몰사업부',
        tasks: [
        ]
      }
    ]
  };

  return (
    <div className="values-page">
      <Helmet>
        <title>{title}</title>
        <link rel="canonical" href={canonical} />
        <meta name="description" content={desc} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={desc} />
        <meta property="og:url" content={canonical} />
        <meta property="og:site_name" content="주식회사 가까운물류" />
        <meta property="og:image" content="https://www.xn--o39ap7bo6pk0bo2x.com/og-1200x630.png?v=1" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={desc} />
        <meta name="twitter:image" content="https://www.xn--o39ap7bo6pk0bo2x.com/og-1200x630.png?v=1" />
      </Helmet>
      <IntroductionTabs type="company">
        <div tabId="values" className="values-content">
          {/* 조직도 섹션 */}
          <section className="organization-section">
            <div className="team-container">
              <div className="organization-header">
                <h2 className="team-section-title">조직도</h2>
                <p className="team-section-subtitle">
                  체계적인 조직 구조로 효율적인 물류 서비스를 제공합니다.
                </p>
              </div>
              
              <div className="org-chart-hierarchical">
                {/* 최상단 레벨: CEO */}
                <div className="org-top-level">
                  <div className="org-box-ceo">
                    <div className="org-name-new">{organizationData.ceo}</div>
                  </div>
                </div>

                {/* 연결선: 대표이사에서 부서들로 */}
                <div className="org-connector-main">
                  <div className="org-connector-vertical"></div>
                  <div className="org-connector-horizontal">
                    <div className="org-connector-node"></div>
                  </div>
                </div>

                {/* 부서 레벨 */}
                <div className="org-departments-level">
                  {organizationData.departments.map((dept) => (
                    <div key={dept.id} className="org-department-wrapper">
                      {/* 연결선: 수평선에서 부서로 */}
                      <div className="org-connector-to-dept">
                        <div className="org-connector-to-dept-vertical"></div>
                        <div className="org-connector-to-dept-node"></div>
                      </div>
                      
                      {/* 부서 박스 */}
                      <div className="org-box-department">
                        <div className="org-name-new">{dept.name}</div>
                      </div>
                      
                      {/* 연결선: 부서에서 하위 기능으로 (tasks가 있을 때만 표시) */}
                      {dept.tasks.length > 0 && (
                        <div className="org-connector-dept"></div>
                      )}
                      
                      {/* 하위 기능들 */}
                      {dept.tasks.length > 0 && (
                        <div className="org-tasks-level">
                          {dept.tasks.map((task, idx) => (
                            <div key={idx} className="org-box-task">
                              <div className="org-name-new">{task}</div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>
        </div>
      </IntroductionTabs>
    </div>
  );
};

export default Values;
